// src/components/common/ImpersonationBanner.js
// Banniere affichee quand un admin est connecte "en tant que" un autre
// utilisateur (mode support). Permet de revenir au compte admin.
// react-icons, aucun emoji. Maxula

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiAlertTriangle, FiLogOut } from 'react-icons/fi';
import { useAuth } from '../../context/AuthContext';

export default function ImpersonationBanner() {
  const auth = useAuth() || {};
  const { isImpersonating, stopImpersonation, user } = auth;
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);

  if (!isImpersonating) return null;

  const back = async () => {
    if (busy) return;
    setBusy(true);
    try {
      if (stopImpersonation) await stopImpersonation();
      navigate('/admin');
    } finally {
      setBusy(false);
    }
  };

  const who = user
    ? (`${user.firstName || ''} ${user.lastName || ''}`.trim() || user.email || 'cet utilisateur')
    : 'cet utilisateur';

  return (
    <div className="w-full bg-amber-500 text-white">
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-between gap-3 text-sm">
        <span className="inline-flex items-center gap-2 font-medium truncate">
          <FiAlertTriangle className="shrink-0" /> Mode support — connecté en tant que {who}
        </span>
        <button type="button" onClick={back} disabled={busy}
          className="inline-flex items-center gap-1.5 bg-white/95 text-amber-700 font-semibold px-3 py-1 rounded-md hover:bg-white disabled:opacity-60 shrink-0">
          <FiLogOut /> Revenir à mon compte
        </button>
      </div>
    </div>
  );
}
